export default __webpack_public_path__ + "static/media/Edit-Grey.6bb68e51.svg";